import React from 'react';

/**
 * Zone vide expliquée.
 *
 * Un tableau qui n'affiche que ses en-têtes laisse croire à un écran cassé.
 * `EmptyState` existait déjà en trois exemplaires dans le projet
 * (InterSiteManagement, PortailEnseignant, SuiviEnseignantsDirection) : celui-ci
 * est destiné à les remplacer, plutôt que d'en écrire un quatrième.
 *
 * `action` reçoit un bouton quand il y a quelque chose à faire — créer le
 * premier élément, ou relâcher un filtre trop étroit.
 */
const EtatVide = ({ icone: Icone, titre, description, action = null, compact = false }) => (
  <div
    className={`flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-gray-200 text-center ${compact ? 'py-8 px-4' : 'py-12 px-6'
      }`}
  >
    {Icone && <Icone size={compact ? 24 : 30} className="text-gray-300" />}
    <p className="text-sm font-semibold text-gray-600">{titre}</p>
    {description && (
      <p className="max-w-md text-[11px] leading-snug text-gray-500">{description}</p>
    )}
    {action && <div className="mt-2">{action}</div>}
  </div>
);

export default EtatVide;
